import * as FrontCubeData from '../../frontCubeData/index';

export interface LayerTxtListParams {
    cube: FreeObjMap,
    checkList: Array<FreeObjMap>,
    tagListMap: FreeObjMap
}

export function getLayerTxtList(params: LayerTxtListParams): Array<string> {
    let result: Array<string> = [];

    for (let i: number = 0; i < params.checkList.length; i++) {
        let value: FreeObjMap = params.checkList[i];

        if (!(value.typeId == 0 || value.typeId == 3)) {
            continue;
        }

        let id: string = value.id ? value.typeId + '-' + value.categoryId + '-' + value.id : value.typeId + '-' + value.categoryId;
        var key: FreeObjMap = params.tagListMap[id];

        if (key === undefined || FrontCubeData.getValue(params.cube.id, key.objKey) === undefined) {
            continue;
        }
        let val: any = FrontCubeData.getValue(params.cube.id, key.objKey);

        result.push(key.fieldName + ':' + (val != null ? val : ' ') + (key.fieldUnit ? key.fieldUnit : ''));
    }

    return result;
}
